import React from 'react';
import PropTypes from 'prop-types';
import {map, shuffle, take} from 'lodash';
import Tooltip from 'src/components/tooltip';
import Text from 'shared/components/text';

// college-discovery-step
import AwardIcon from './award-icon';

class AwardsList extends React.Component {
  static propTypes = {
    achievementItems: PropTypes.arrayOf(
      PropTypes.shape({
        emoji: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        scholarshipType: PropTypes.string.isRequired,
      })
    ),
    numberEmojisToShow: PropTypes.number.isRequired,
  };

  moreText = (achievementItems, numberEmojisToShow) => {
    const remainingItems = achievementItems.slice(numberEmojisToShow);

    if (!remainingItems.length) {
      return null;
    }

    const awardNames = map(remainingItems, (remainingItem) => remainingItem.name).join(', ');

    return (
      <Tooltip title={awardNames} placement="top">
        <span
          alt={awardNames}
          className="college-discovery-step-college-card-awards-list-more-text"
        >
          {` + ${remainingItems.length} more`}
        </span>
      </Tooltip>
    );
  };

  render() {
    const {achievementItems, numberEmojisToShow} = this.props;

    if (!achievementItems.length) {
      return null;
    }

    this.shuffledAchievementItems = this.shuffledAchievementItems || [];

    if (!this.shuffledAchievementItems.length && achievementItems.length) {
      this.shuffledAchievementItems = shuffle(achievementItems);
    }

    return (
      <div className="college-discovery-step-college-card-awards-list">
        <Text
          inline
          emphasis
          weight={6}
          className="college-discovery-step-college-card-awards-list-awards-for-text"
        >
          Awards for:{' '}
        </Text>
        {map(take(this.shuffledAchievementItems, numberEmojisToShow), (achievementItem, i) => (
          <AwardIcon key={i} achievementItem={achievementItem} />
        ))}
        {this.moreText(this.shuffledAchievementItems, numberEmojisToShow)}
      </div>
    );
  }
}

export default AwardsList;
